import { render, staticRenderFns } from "./BeneficiariesComponent.vue?vue&type=template&id=9e140650&"
import script from "./BeneficiariesComponent.vue?vue&type=script&lang=js&"
export * from "./BeneficiariesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports